/**
 * Initializes carousels.
 * 
 * A carousel mus have the genral sctructure as follows:
 *  - Wrapper
 *    <div data-carousel='json with options'>...</div>
 *    + Plugins (optional):
 *      - data-carousel-class-name='json with ClassName options'
 *      - data-carousel-wheel-gasture='true' - WheelGasturesPlugin
 * 
 *  - Viewport
 *    <div data-carousel-viewport>...</div>
 * 
 *  - Container of slides
 *    By default, Embla will choose the first direct child element of the viewport.
 *    You may provide your container with using option 'container: ... '.
 * 
 *  - Controls
 *    <div data-carousel-controls>...</div>
 * 
 *  - Buttons:
 *    Inside the carousel controls div:
 *      - Previous button: <div data-carousel-prev>...</div>
 *      - Next button: <div data-carousel-next>...</div
 */

import EmblaCarousel from "embla-carousel"
import ClassNames from "embla-carousel-class-names"
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures"

class Carousel {
  init() {
    const carousels = document.querySelectorAll('[data-carousel]')

    carousels.forEach(carousel => {
      const viewport = carousel.querySelector('[data-carousel-viewport]')

      if(!viewport) {
        console.error('Carousel viewport not found')
        return
      }

      const carouselMatchQuery = carousel.dataset.carouselMatchQuery || null;
      if(carouselMatchQuery) {
        if(!window.matchMedia(carouselMatchQuery).matches) {
          return;
        }
      }
      
      const options = carousel.dataset.carousel ? JSON.parse(carousel.dataset.carousel) : []
      const classNameOptions = carousel.dataset.carouselClassName ? JSON.parse(carousel.dataset.carouselClassName) : null
      const wheelGestureOptions = carousel.dataset.carouselWheelGesture ? true : false
      
      let plugins = []

      if(classNameOptions) {
        plugins.push(ClassNames(classNameOptions))
      }

      if(wheelGestureOptions) {
        plugins.push(WheelGesturesPlugin())
      }

      const emblaApi = new EmblaCarousel(viewport, options, plugins)

      const controls = carousel.querySelector('[data-carousel-controls]')

      if(controls) {
        const prevButton = controls.querySelector('[data-carousel-prev]')
        const nextButton = controls.querySelector('[data-carousel-next]')

        if(prevButton && nextButton) {
          prevButton.addEventListener('click', () => emblaApi.scrollPrev())
          nextButton.addEventListener('click', () => emblaApi.scrollNext())
        }

        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) {
                prevButton.removeAttribute('disabled');
            }
            else {
                prevButton.setAttribute('disabled', 'disabled');
            }

            if (emblaApi.canScrollNext()) {
                nextButton.removeAttribute('disabled');
            }
            else {
                nextButton.setAttribute('disabled', 'disabled');
            }
        }

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState)
      }

      // If carousel container has id, let's add its emblaApi to global array
      if(carousel.id) {
        window.emblaApis[carousel.id] = emblaApi
      }
      
    })
  }
}

export {Carousel}